{
  "columnResizer": "Средство изменения размера столбцов",
  "loading": "Загрузка...",
  "loadingMore": "Дополнительная загрузка...",
  "resizeColumn": "Изменить размер столбца",
  "sortAscending": "Сортировать по возрастанию",
  "sortDescending": "Сортировать по убыванию"
}
